import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../Global/axios";

const getQuotationData = createAsyncThunk("api/quotation", async (token) => {
  try {
    const response = await axios.get("/dashboard/quotation", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data;
  } catch (e) {
    throw new Error(e.message);
  }
});

const quotationDataSlice = createSlice({
  name: "quotation",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {}, // You can define your other regular reducers here if needed.
  extraReducers: (builder) => {
    builder
      .addCase(getQuotationData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
        state.status = true
      })
      .addCase(getQuotationData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getQuotationData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getQuotationData };
export default quotationDataSlice.reducer;
